/* 1221 · Personalizzazione nella scheda prodotto (CTRL+G, V3, 22/10/2026; V2.3 del 14/10/2026; V2.2 del 12/10/2026)
   - collega i campi al form del prodotto (attributo form)
   - con supplemento: al «Aggiungi al carrello» manda insieme prodotto + «Personalizzazione» (+X €)
   - anteprima sulla foto frontale (-01) secondo la tecnica:
       ricamo   testo in Helvetica nel colore scelto, in scala reale (V3): la grandezza scelta (2 o 3 cm) diventa
                l'altezza delle lettere sulla foto, grazie a cfg.anteprima.cm (% della larghezza della foto per 1 cm).
                Se la scritta è più larga dello spazio utile (cfg.anteprima.max, in cm) compare un avviso sotto il campo.
                cfg.anteprima.allinea = 'destra': la scritta finisce nel punto x, y (come sul quaderno vero).
       stampa   stampa a caldo oro o argento (dal colore della variante «Lettering» se c'è), spaziatura normale (V3)
       metallo  lettere 3D cromate, in riga o in colonna (cfg.anteprima.vert); in colonna con alto = true il punto y
                è la cima della prima lettera e passo è lo spazio tra le lettere (V3, misurati sulle foto vere)
       patch    lettere in patch di spugna (immagini 1221-patch-a.png … z.png nei File)
       borchie  lettera in microborchie disegnate in SVG (V2.3; prima immagini 1221-studs-*.png)
   - cfg.anteprima.per: correzioni per singola foto, chiave = parte del nome del file (es. {"blu-01": {"x": 51}})
   - V3.1 (22/10/2026, Fabio): dove si sceglie tra iniziali e frase (cfg.frase, i beauty) la grandezza non si sceglie:
     le iniziali sono grandi, la frase piccola (la grandezza più grande e la più piccola di cfg.grandezze).
     cfg.frase.anteprima (facoltativo) sposta l'anteprima della frase (x, y, allinea, max); l'etichetta del campo diventa
     cfg.frase.etichetta o «La tua frase». Copia prima: bk-20261022-1221-personalizza.js
   - V3.2 (22/10/2026, Fabio): cfg.anteprima.righe = N fa andare a capo il ricamo dentro lo spazio utile (max, in cm),
     su N righe al massimo, centrate (come su Amelie); l'avviso compare solo se servono più righe.
   - V3.3 (29/10/2026, richiesta di Donatella): prezzo secondo la lunghezza. cfg.oltre = {"caratteri": 3, "prezzo": 40}:
     fino a 3 caratteri (spazi e punti compresi) nessun supplemento, dal 4° carattere + 40 €. Con cfg.oltre il prezzo di
     cfg.frase non si usa più (resta solo per il tema vecchio); scegliendo «Frase» servono almeno 4 caratteri.
     Bordi: la scritta non può uscire dal pezzo. Se servono più righe di cfg.anteprima.righe, o se una parola da sola è
     più larga dello spazio utile, compare l'avviso e il prodotto non entra nel carrello finché il testo non ci sta.
     cfg.anteprima.base = true: il punto y è il fondo della scritta, che va a capo verso l'alto (beauty, quaderno).
     Copia prima: bk-20261029-1221-personalizza.js
   - V3.4 (3/11/2026, QA P4): QA-114 · gli ascoltatori su window e document (resize, variant:change, load, submit) e quelli
     su form, sezione e galleria hanno un AbortController per blocco: quando il tema ridisegna il blocco (cambio variante)
     quelli del blocco vecchio si tolgono. QA-121 · con il supplemento attivo, sopra «Aggiungi al carrello» compare
     «Totale con la personalizzazione: 230 €» (prezzo della variante da data-prezzo, aggiornato da variant:change). */
(function () {
  'use strict';

  function euro(n) { return '+ ' + n + ' €'; }
  /* V3.4 (QA-121): importo in euro all'italiana, senza decimali se sono zero (230 €, 230,50 €) */
  function importo(cent) {
    var e = Math.round(cent) / 100;
    var t = e % 1 === 0 ? String(e) : e.toFixed(2).replace('.', ',');
    return t.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
  }
  /* V3.4 (QA-114): blocchi attivi con il loro AbortController; quelli tolti dalla pagina si spengono */
  var ISTANZE = [];
  function spegniStaccati() {
    ISTANZE = ISTANZE.filter(function (x) {
      if (x.root.isConnected) return true;
      if (x.ac) x.ac.abort();
      if (x.somma && x.somma.isConnected && x.somma.__xpRoot === x.root) x.somma.hidden = true;
      return false;
    });
  }
  /* lettere in microborchie (V2.3): i dati stanno in 1221-borchie.js, caricato solo dove serve (V3) */
  var SCRIPT = (document.currentScript && document.currentScript.src) || '';
  function borchieDati(fatto) {
    if (window.X1221_BORCHIE) return window.X1221_BORCHIE;
    if (!document.getElementById('x-pers-borchie') && SCRIPT) {
      var sc = document.createElement('script');
      sc.id = 'x-pers-borchie';
      sc.src = SCRIPT.replace('1221-personalizza.js', '1221-borchie.js');
      sc.onload = fatto;
      document.head.appendChild(sc);
    }
    return null;
  }
  /* altezza delle maiuscole in Helvetica, in em: serve per dare alle lettere ricamate l'altezza reale scelta */
  var CAP_HELVETICA = 0.717;
  /* il tema ridisegna il blocco quando cambia la variante: lo stato resta qui e viene ripreso */
  var STATO = window.__x1221Stato || (window.__x1221Stato = {});
  var LETTERA = /[A-Za-zÀ-ÖØ-öø-ÿ]/g;

  /* carattere delle lettere in metallo e della stampa a caldo: una sola volta per pagina */
  /* V1.30 (30/10/2026, QA-002): Playfair Display non arriva più da Google Fonts. I file sono negli asset del tema
     (x1221-playfair-500.woff2, x1221-playfair-700.woff2) e il @font-face è in snippets/1221-personalizza.liquid:
     il browser li scarica solo quando l'anteprima li usa. */
  function caricaPlayfair() {}

  function init(root) {
    if (!root || root.__xp) return;
    root.__xp = true;
    var cfg = {};
    var addon = {};
    try { cfg = JSON.parse(root.dataset.cfg || '{}'); } catch (e) {}
    try { addon = JSON.parse(root.dataset.addon || '{}'); } catch (e) {}
    if (cfg.fisso) return;

    var tipo = cfg.tipo || 'ricamo';
    var section = root.closest('.shopify-section') || document;
    var form = section.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    /* V3.4 (QA-114): un AbortController per blocco; opt() aggiunge il segnale alle opzioni degli ascoltatori */
    var ac = window.AbortController ? new AbortController() : null;
    function opt(o) { o = o || {}; if (ac) o.signal = ac.signal; return o; }
    var istanza = { root: root, ac: ac, somma: null };
    ISTANZE.push(istanza);
    /* V3.4 (QA-121): prezzo della variante in centesimi, per il totale accanto al pulsante */
    var prezzoCent = Number(root.dataset.prezzo || 0);
    var formId = form.getAttribute('id');
    if (tipo === 'stampa' || tipo === 'metallo') caricaPlayfair();

    var box = root.querySelector('.x-pers__box');
    var apri = root.querySelector('.x-pers__apri');
    var chiudi = root.querySelector('[data-x-chiudi]');
    var testo = root.querySelector('[data-x-testo]');
    var conta = root.querySelector('[data-x-conta]');
    var totale = root.querySelector('[data-x-totale]');
    var avviso = root.querySelector('[data-x-avviso]');
    var cuore = root.querySelector('[data-x-cuore]');
    /* V3.1: con la scelta iniziali / frase la grandezza dipende dalla scelta, quindi il campo «Grandezza» si toglie */
    var autoGrandezza = !!(cfg.frase && tipo === 'ricamo');
    if (autoGrandezza) {
      var grIn = root.querySelector('input[name="properties[Grandezza]"]');
      var grCampo = grIn && grIn.closest('fieldset');
      if (grCampo) grCampo.remove();
    }
    var etichetta = root.querySelector('[data-x-etichetta]');
    var etichettaBase = etichetta ? etichetta.textContent : '';
    var campi = Array.prototype.slice.call(root.querySelectorAll('input'));
    var attiva = !!cfg.obbligatoria;
    var maxBase = (cfg.testo && cfg.testo.max) || 25;
    var lettere = cfg.testo && cfg.testo.lettere;
    var soloLettere = tipo === 'patch' || tipo === 'borchie';
    var maiuscolo = tipo !== 'ricamo';
    /* V3.3: supplemento secondo la lunghezza */
    var oltre = cfg.oltre && Number(cfg.oltre.prezzo) > 0 ? cfg.oltre : null;
    var soglia = oltre ? Number(oltre.caratteri || 0) : 0;
    var troppo = false;

    campi.forEach(function (el) { el.setAttribute('form', formId); });
    var chiave = (box && box.id) || root.dataset.titolo;
    function salva() {
      var vals = {};
      campi.forEach(function (el) {
        if (el.type === 'radio' || el.type === 'checkbox') { if (el.checked) vals[el.name] = el.value; }
        else if (el.type !== 'hidden') vals[el.name] = el.value;
      });
      STATO[chiave] = { attiva: attiva, vals: vals };
    }
    function riprendi() {
      var st = STATO[chiave];
      if (!st) return;
      if (!cfg.obbligatoria) {
        attiva = st.attiva;
        if (box) box.hidden = !attiva;
        if (apri) apri.setAttribute('aria-expanded', attiva ? 'true' : 'false');
      }
      campi.forEach(function (el) {
        if (!(el.name in st.vals)) return;
        if (el.type === 'radio' || el.type === 'checkbox') el.checked = st.vals[el.name] === el.value;
        else if (el.type !== 'hidden') el.value = st.vals[el.name];
      });
    }

    function scelta() {
      var t = root.querySelector('[data-x-tipo]:checked');
      return t ? t.dataset.xTipo : 'iniziali';
    }
    /* V3.3: caratteri scritti, spazi e punti compresi (quelli all'inizio e alla fine non contano) */
    function lunghezza() { return testo ? testo.value.trim().length : 0; }
    function extra() {
      if (!attiva) return 0;
      var n = Number(cfg.prezzo || 0);
      if (oltre) { if (lunghezza() > soglia) n += Number(oltre.prezzo); }
      else if (cfg.frase && scelta() === 'frase') n += Number(cfg.frase.prezzo || 0);
      return n;
    }
    function pulisci() {
      if (!testo) return;
      var v = testo.value;
      if (soloLettere) v = v.replace(/[^A-Za-z]/g, '');
      if (maiuscolo) v = v.toUpperCase();
      if (lettere && !(cfg.frase && scelta() === 'frase')) {
        var n = 0, out = '';
        for (var i = 0; i < v.length; i++) {
          if (/[A-Za-zÀ-ÖØ-öø-ÿ]/.test(v[i])) { if (n >= lettere) continue; n++; }
          out += v[i];
        }
        v = out;
      }
      if (v !== testo.value) {
        var pos = testo.selectionStart;
        testo.value = v;
        try { testo.setSelectionRange(pos, pos); } catch (e) {}
      }
    }
    function aggiorna() {
      campi.forEach(function (el) { el.disabled = !attiva; });
      if (cuore) cuore.disabled = !attiva;
      if (testo) {
        var frase = !!(cfg.frase && scelta() === 'frase');
        var max = frase ? cfg.frase.max : maxBase;
        if (etichetta && cfg.frase) etichetta.textContent = frase ? (cfg.frase.etichetta || 'La tua frase') : etichettaBase;
        /* V3.3: la frase a pagamento parte dal 4° carattere; fino a 3 si sceglie «Iniziali», che è gratis.
           Prima si toglie il minimo, poi si cambia il massimo (minimo > massimo dà errore) */
        testo.removeAttribute('minlength');
        testo.maxLength = max;
        if (oltre && frase) testo.minLength = Math.min(soglia + 1, max);
        if (testo.value.length > max) testo.value = testo.value.slice(0, max);
        pulisci();
        testo.required = attiva;
        if (conta) {
          if (lettere && !frase) {
            conta.textContent = (testo.value.match(LETTERA) || []).length + '/' + lettere;
          } else {
            conta.textContent = testo.value.length + '/' + max;
          }
        }
      }
      root.querySelectorAll('[data-x-val="colore"]').forEach(function (s) {
        var c = root.querySelector('input[name="properties[Colore del testo]"]:checked');
        if (c) s.textContent = c.value;
      });
      var e = extra();
      somma(e);
      if (totale) {
        totale.hidden = !(attiva && e > 0);
        totale.textContent = 'Supplemento personalizzazione: ' + euro(e) +
          (oltre && !cfg.frase ? ' (oltre i ' + soglia + ' caratteri)' : '') + ', aggiunto al carrello insieme al prodotto.';
      }
      root.classList.toggle('x-pers--attiva', attiva);
      salva();
      anteprima();
    }

    if (apri) apri.addEventListener('click', function () {
      attiva = true; box.hidden = false; apri.setAttribute('aria-expanded', 'true'); aggiorna();
      if (testo) testo.focus();
    });
    if (chiudi) chiudi.addEventListener('click', function () {
      attiva = false; box.hidden = true; apri && apri.setAttribute('aria-expanded', 'false'); aggiorna();
      apri && apri.focus();
    });
    if (cuore && testo) cuore.addEventListener('click', function () {
      if (testo.value.length >= testo.maxLength) return;
      var s = testo.selectionStart == null ? testo.value.length : testo.selectionStart;
      var f = testo.selectionEnd == null ? s : testo.selectionEnd;
      testo.value = testo.value.slice(0, s) + '♥' + testo.value.slice(f);
      testo.focus();
      try { testo.setSelectionRange(s + 1, s + 1); } catch (e) {}
      aggiorna();
    });
    /* V3.4 (QA-121): «Totale con la personalizzazione» sopra il pulsante del carrello, una riga per modulo */
    function somma(e) {
      var bb = form.querySelector('buy-buttons');
      if (!bb) return;
      var el = istanza.somma || form.querySelector('[data-x-somma]');
      if (!el) {
        el = document.createElement('p');
        el.className = 'x-pers__somma';
        el.setAttribute('data-x-somma', '');
        el.setAttribute('aria-live', 'polite');
        el.hidden = true;
        bb.parentNode.insertBefore(el, bb);
      }
      istanza.somma = el;
      el.__xpRoot = root;
      var qEl = form.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"][form="' + formId + '"]');
      var q = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
      var mostra = attiva && e > 0 && prezzoCent > 0;
      el.hidden = !mostra;
      if (mostra) el.textContent = 'Totale con la personalizzazione' + (q > 1 ? ' (' + q + ' pezzi)' : '') + ': ' + importo((prezzoCent + e * 100) * q);
    }

    root.addEventListener('input', aggiorna);
    root.addEventListener('change', aggiorna);
    form.addEventListener('change', function () { anteprima(); somma(extra()); }, opt());
    document.addEventListener('variant:change', function (ev) {
      var v = ev && ev.detail && ev.detail.variant;
      if (v && v.price != null) { prezzoCent = Number(v.price); somma(extra()); }
    }, opt());

    /* ---------- anteprima sulla foto ---------- */
    var A = cfg.anteprima;
    var base = root.dataset.lettere || '';
    var ants = [];
    var osservate = [];
    var rq = null;
    function presto() { if (rq) return; rq = requestAnimationFrame(function () { rq = null; anteprima(); }); }
    var ro = (A && window.ResizeObserver) ? new ResizeObserver(presto) : null;
    function osserva(img) {
      if (!ro || osservate.indexOf(img) !== -1) return;
      osservate.push(img);
      ro.observe(img);
      if (!img.complete) img.addEventListener('load', presto, { once: true });
    }
    function nomeFile(img) {
      var src = (img.currentSrc || img.src || '').split('?')[0];
      return src.substring(src.lastIndexOf('/') + 1);
    }
    function foto(img) {
      var nome = nomeFile(img);
      var chiavi = (A && A.foto) || ['-01.'];
      return chiavi.some(function (k) { return nome.indexOf(k) !== -1; });
    }
    /* impostazioni della foto: quelle del prodotto, corrette da A.per se il nome del file lo prevede */
    function impostazioni(img) {
      var B = A;
      if (A && cfg.frase && cfg.frase.anteprima && scelta() === 'frase') {
        /* V3.1: la frase può stare in un altro punto del pezzo */
        B = {};
        Object.keys(A).forEach(function (k) { B[k] = A[k]; });
        Object.keys(cfg.frase.anteprima).forEach(function (k) { B[k] = cfg.frase.anteprima[k]; });
      }
      if (!B || !B.per) return B;
      var nome = nomeFile(img);
      var out = {};
      Object.keys(B).forEach(function (k) { out[k] = B[k]; });
      Object.keys(B.per).forEach(function (k) {
        if (nome.indexOf(k) === -1) return;
        Object.keys(B.per[k]).forEach(function (j) { out[j] = B.per[k][j]; });
      });
      return out;
    }
    function trova() {
      var gal = section.querySelector('product-gallery') || section;
      var lista = Array.prototype.slice.call(gal.querySelectorAll('.product-gallery__media img, img'));
      var visti = [];
      lista.forEach(function (img) {
        if (visti.indexOf(img) !== -1) return;
        if (!foto(img)) return;
        visti.push(img);
        osserva(img);
        var holder = img.parentElement;
        var gia = holder.querySelector(':scope > .x-pers-ant');
        if (gia) {
          if (!ants.some(function (o) { return o.el === gia; })) ants.push({ img: img, el: gia });
          return;
        }
        if (getComputedStyle(holder).position === 'static') holder.style.position = 'relative';
        var el = document.createElement('div');
        el.className = 'x-pers-ant x-pers-ant--' + tipo;
        el.setAttribute('aria-hidden', 'true');
        holder.appendChild(el);
        ants.push({ img: img, el: el });
      });
    }
    function metalloStampa() {
      if (A && A.colore) return A.colore;
      var sel = document.querySelectorAll('input[form="' + formId + '"]:checked, #' + formId + ' input:checked, #' + formId + ' select');
      for (var i = 0; i < sel.length; i++) {
        var lb = sel[i].id ? document.querySelector('label[for="' + sel[i].id + '"]') : null;
        var v = ((lb ? lb.textContent : '') + ' ' + (sel[i].value || '')).toLowerCase();
        if (/\b(gold|oro)\b/.test(v)) return 'oro';
        if (/\b(silver|argento)\b/.test(v)) return 'argento';
      }
      var info = section.querySelectorAll('.variant-picker__option-info span');
      for (var j = 0; j < info.length; j++) {
        var t = info[j].textContent.toLowerCase();
        if (/\b(gold|oro)\b/.test(t)) return 'oro';
        if (/\b(silver|argento)\b/.test(t)) return 'argento';
      }
      return 'oro';
    }
    function lettereImg(v, set) {
      var frag = document.createDocumentFragment();
      v.replace(/[^A-Za-z]/g, '').toLowerCase().split('').forEach(function (c) {
        var i = document.createElement('img');
        i.alt = '';
        i.decoding = 'async';
        i.src = base + '1221-' + set + '-' + c + '.png';
        frag.appendChild(i);
      });
      return frag;
    }
    /* V2.3 (14/10/2026, nota di Fabio): le borchie si disegnano qui, come nella foto originale di Donatella:
       borchie cromate a cupola (metà alta scura, metà bassa argento), lungo il tratto di una lettera stretta.
       Le coordinate di ogni lettera sono in BORCHIE (x, y in frazioni dell'altezza della lettera; w = larghezza). */
    var NS = 'http://www.w3.org/2000/svg';
    var nSvg = 0;
    function borchieSvg(v) {
      var BORCHIE = borchieDati(presto) || {};
      var lett = v.replace(/[^A-Za-z]/g, '').toUpperCase().split('').filter(function (c) { return BORCHIE[c]; });
      var R = 0.043, GAP = 0.18, M = R * 1.6;
      var tot = 0;
      lett.forEach(function (c, i) { tot += BORCHIE[c].w + (i ? GAP : 0); });
      var svg = document.createElementNS(NS, 'svg');
      var id = 'x-borchia-' + (++nSvg);
      svg.setAttribute('viewBox', (-M) + ' ' + (-M) + ' ' + (tot + 2 * M) + ' ' + (1 + 2 * M));
      svg.setAttribute('class', 'x-pers-borchie');
      svg.style.height = 'calc(var(--h) * ' + (1 + 2 * M) + ')';
      svg.style.width = 'auto';
      svg.style.display = 'block';
      svg.style.overflow = 'visible';
      svg.innerHTML = '<defs>' +
        '<linearGradient id="' + id + '" x1="0" y1="0" x2="0" y2="1">' +
        '<stop offset="0" stop-color="#8a8a86"/><stop offset=".14" stop-color="#3a3836"/><stop offset=".46" stop-color="#2a2826"/>' +
        '<stop offset=".5" stop-color="#bdbcb8"/><stop offset=".72" stop-color="#f4f4f1"/><stop offset="1" stop-color="#a9a8a4"/></linearGradient>' +
        '<filter id="' + id + '-o" x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="' + (R * 0.22).toFixed(4) + '"/></filter>' +
        '</defs>';
      var x0 = 0, ombre = '', borchie = '', luci = '';
      lett.forEach(function (c, i) {
        if (i) x0 += GAP;
        BORCHIE[c].p.forEach(function (p) {
          var cx = x0 + p[0], cy = p[1];
          ombre += '<circle cx="' + (cx + R * 0.14).toFixed(4) + '" cy="' + (cy + R * 0.2).toFixed(4) + '" r="' + (R * 1.05).toFixed(4) + '"/>';
          borchie += '<circle cx="' + cx.toFixed(4) + '" cy="' + cy.toFixed(4) + '" r="' + R + '"/>';
          luci += '<ellipse cx="' + (cx - R * 0.28).toFixed(4) + '" cy="' + (cy - R * 0.62).toFixed(4) + '" rx="' + (R * 0.38).toFixed(4) + '" ry="' + (R * 0.14).toFixed(4) + '"/>';
        });
        x0 += BORCHIE[c].w;
      });
      svg.innerHTML += '<g fill="rgba(0,0,0,.55)" filter="url(#' + id + '-o)">' + ombre + '</g>' +
        '<g fill="url(#' + id + ')" stroke="rgba(235,235,232,.9)" stroke-width="' + (R * 0.1).toFixed(4) + '">' + borchie + '</g>' +
        '<g fill="rgba(255,255,255,.55)">' + luci + '</g>';
      return svg;
    }
    function cmScelti() {
      var sc = root.querySelector('input[name="properties[Grandezza]"]:checked');
      var cm = sc ? parseFloat(sc.dataset.cm) : NaN;
      if (!sc && autoGrandezza && cfg.grandezze) {
        /* V3.1: iniziali con la grandezza più grande, frase con la più piccola */
        var gg = String(cfg.grandezze).split('|').map(function (g) { return parseFloat(g.split(':').pop()); }).filter(function (n) { return n > 0; });
        if (gg.length) cm = scelta() === 'frase' ? Math.min.apply(null, gg) : Math.max.apply(null, gg);
      }
      if (!cm) cm = sc && sc.dataset.scala === '2' ? 3 : 2;
      return cm;
    }
    /* disegna la scritta su una foto; per il ricamo restituisce la larghezza della scritta in cm */
    function disegna(o, v) {
      var el = o.el, img = o.img;
      var P = impostazioni(img);
      var w = img.clientWidth, h = img.clientHeight;
      el.hidden = !v || w < 120; /* niente scritta sulle miniature: troppo piccola, e falserebbe la misura in cm */
      if (el.hidden) return 0;
      var dx = (P.x == null ? 50 : P.x) / 100 * w, dy = (P.y == null ? 50 : P.y) / 100 * h;
      o.x0 = img.offsetLeft + dx;
      o.h0 = 0;
      o.f0 = 0;
      el.style.left = o.x0 + 'px';
      el.style.top = (img.offsetTop + dy) + 'px';
      var ruota = P.r ? ' rotate(' + P.r + 'deg)' : '';
      /* V3.3: con base = true il punto y è il fondo della scritta (le righe in più salgono) */
      var vy = P.base ? '-100%' : '-50%', oy = P.base ? '100%' : '50%';
      el.style.transformOrigin = '50% ' + oy;
      el.style.transform = 'translate(-50%,' + vy + ')' + ruota;
      el.textContent = '';
      el.style.color = '';
      el.style.fontFamily = '';
      el.classList.remove('x-pers-ant--vert');
      el.style.removeProperty('width');
      el.style.removeProperty('white-space');
      el.style.removeProperty('text-align');
      el.style.removeProperty('line-height');
      o.righe = 0;
      o.fuori = false;
      if (tipo === 'borchie') {
        o.h0 = (P.h || 10) / 100 * w;
        el.style.setProperty('--h', o.h0 + 'px');
        el.appendChild(borchieSvg(v));
        nelPezzo(o, P);
        return 0;
      }
      if (tipo === 'patch') {
        o.h0 = (P.h || 10) / 100 * w;
        el.style.setProperty('--h', o.h0 + 'px');
        el.appendChild(lettereImg(v, 'patch'));
        /* le lettere in spugna sono immagini: si rimisura quando arrivano */
        el.querySelectorAll('img').forEach(function (i) {
          if (!i.complete) i.addEventListener('load', function () { if (o.el === el) nelPezzo(o, P); }, { once: true });
        });
        nelPezzo(o, P);
        return 0;
      }
      var size = (P.w || 4) / 100 * w;
      var pxcm = 0;
      if (tipo === 'ricamo') {
        var cm = cmScelti();
        if (P.cm) {
          /* scala reale: la grandezza scelta è l'altezza delle maiuscole sul pezzo */
          pxcm = P.cm / 100 * w;
          size = cm * pxcm / CAP_HELVETICA;
        } else if (cm >= 3) {
          size *= 1.4;
        }
        var col = root.querySelector('input[name="properties[Colore del testo]"]:checked');
        el.style.setProperty('--x-c', col ? col.dataset.hex : (P.hex || '#2b3f73'));
        if (P.allinea === 'destra') {
          el.style.transformOrigin = '100% ' + oy;
          el.style.transform = 'translate(-100%,' + vy + ')' + ruota;
        }
      }
      if (tipo === 'stampa') el.dataset.metallo = metalloStampa();
      if (P.sp != null) el.style.setProperty('--x-sp', P.sp + 'em'); else el.style.removeProperty('--x-sp');
      el.style.fontSize = size + 'px';
      o.f0 = size;
      if (tipo === 'metallo' && P.vert) {
        el.classList.add('x-pers-ant--vert');
        if (P.passo != null) el.style.setProperty('--x-passo', P.passo + 'em');
        if (P.alto) {
          el.style.transformOrigin = '50% 0';
          el.style.transform = 'translate(-50%,0)' + ruota;
        }
        v.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ]/g, '').split('').forEach(function (c) {
          var s = document.createElement('span'); s.textContent = c; el.appendChild(s);
        });
      } else {
        el.textContent = v;
      }
      /* V3.2: a capo dentro lo spazio utile, su P.righe righe al massimo */
      if (tipo === 'ricamo' && P.righe > 1 && P.max && pxcm && el.offsetWidth > P.max * pxcm) {
        el.style.setProperty('width', (P.max * pxcm) + 'px', 'important');
        el.style.setProperty('white-space', 'normal', 'important');
        el.style.setProperty('text-align', P.allinea === 'destra' ? 'right' : 'center');
        el.style.setProperty('line-height', '1.3');
        o.righe = Math.round(el.offsetHeight / (size * 1.3));
        /* V3.3: una parola da sola più larga dello spazio esce dal pezzo anche andando a capo */
        o.fuori = el.scrollWidth > el.clientWidth + 1;
        if (o.fuori) return el.scrollWidth / pxcm;
        return o.righe > P.righe ? P.max * o.righe / P.righe : 0;
      }
      nelPezzo(o, P);
      return pxcm ? el.offsetWidth / pxcm : 0;
    }
    /* V3.3: lettere in spugna, metallo, borchie e stampa restano dentro il pezzo. cfg.anteprima.bordi = [sinistra, destra]
       in % della larghezza della foto: se la scritta esce la si sposta verso l'interno; se è più larga del pezzo
       (per esempio una W in spugna sul charm) la si rimpicciolisce quanto basta. Il ricamo invece si blocca (max, righe). */
    function nelPezzo(o, P) {
      var el = o.el;
      if (!P || !P.bordi || P.r || el.hidden || tipo === 'ricamo') return;
      el.style.left = o.x0 + 'px';
      if (o.h0) el.style.setProperty('--h', o.h0 + 'px'); else if (o.f0) el.style.fontSize = o.f0 + 'px';
      var ir = o.img.getBoundingClientRect();
      if (!ir.width) return;
      var k = o.img.clientWidth / ir.width;
      var a = ir.left + P.bordi[0] / 100 * ir.width, b = ir.left + P.bordi[1] / 100 * ir.width;
      var r = el.getBoundingClientRect();
      if (r.width > b - a && r.width > 0) {
        var s = (b - a) / r.width;
        if (o.h0) el.style.setProperty('--h', (o.h0 * s) + 'px'); else if (o.f0) el.style.fontSize = (o.f0 * s) + 'px';
        r = el.getBoundingClientRect();
      }
      var sp = 0;
      if (r.right > b) sp = b - r.right; else if (r.left < a) sp = a - r.left;
      if (sp) el.style.left = (o.x0 + sp * k) + 'px';
    }
    function anteprima() {
      if (!A) return;
      if (!root.isConnected) { if (ro) ro.disconnect(); return; }
      ants = ants.filter(function (o) { return o.el.isConnected && o.img.isConnected; });
      trova();
      var v = attiva && testo ? testo.value.trim() : '';
      var largo = 0, maxCm = 0, righe = 0, maxRighe = 0, fuori = false;
      ants.forEach(function (o) {
        var l = disegna(o, v);
        if (l > largo) { largo = l; maxCm = impostazioni(o.img).max || 0; righe = o.righe || 0; maxRighe = impostazioni(o.img).righe || 0; fuori = !!o.fuori; }
      });
      troppo = !!(tipo === 'ricamo' && v && maxCm && largo > maxCm + 0.3);
      /* V3.3: si consiglia la grandezza Piccola solo se c'è e non è già scelta (la prima della lista) */
      var gr = root.querySelectorAll('input[name="properties[Grandezza]"]');
      var piccola = !autoGrandezza && gr.length > 1 && !gr[0].checked;
      if (testo) testo.setCustomValidity(troppo ? 'La scritta non sta sul pezzo: ' + (piccola ? 'scegli la grandezza Piccola o accorcia il testo.' : 'accorcia il testo.') : '');
      if (avviso) {
        avviso.hidden = !troppo;
        if (troppo) {
          var cm = cmScelti();
          var consiglio = piccola ? 'Scegli la grandezza Piccola o accorcia il testo.' : 'Accorcia il testo.';
          if (fuori) {
            avviso.textContent = 'Con lettere alte ' + String(cm).replace('.', ',') + ' cm una parola da sola è più larga dello spazio sul pezzo (circa ' +
              String(maxCm).replace('.', ',') + ' cm) e uscirebbe dal bordo. ' + consiglio;
            return;
          }
          if (righe) {
            avviso.textContent = 'Con lettere alte ' + String(cm).replace('.', ',') + ' cm la scritta va su ' + righe + ' righe, ma su questo pezzo ne stanno ' +
              maxRighe + ' di circa ' + String(maxCm).replace('.', ',') + ' cm. ' + consiglio;
            return;
          }
          avviso.textContent = 'Con lettere alte ' + String(cm).replace('.', ',') + ' cm la scritta è lunga circa ' +
            Math.round(largo) + ' cm, ma su questo pezzo lo spazio è di circa ' + String(maxCm).replace('.', ',') + ' cm. ' +
            (autoGrandezza ? 'Accorcia il testo.' : piccola ? 'Scegli la grandezza Piccola o accorcia il testo.' : 'Accorcia il testo, per esempio con le iniziali.');
        }
      }
    }
    if (A) {
      var rid = null;
      window.addEventListener('resize', function () { clearTimeout(rid); rid = setTimeout(anteprima, 120); }, opt());
      /* V3.3: non per le lettere dell'anteprima (si ridisegnerebbe a ogni lettera caricata) */
      section.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG' && !e.target.closest('.x-pers-ant')) anteprima(); }, opt({ capture: true }));
      document.addEventListener('variant:change', function () { setTimeout(anteprima, 60); }, opt());
      window.addEventListener('load', presto, opt());
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(presto);
      var car = section.querySelector('scroll-carousel, .product-gallery__carousel');
      if (car) {
        car.addEventListener('scroll', function () { clearTimeout(rid); rid = setTimeout(anteprima, 80); }, opt({ passive: true }));
        car.addEventListener('scrollend', presto, opt());
      }
      [0, 150, 400, 1000, 2500].forEach(function (t) { setTimeout(presto, t); });
    }

    /* ---------- invio: con supplemento manda prodotto + personalizzazione in una sola richiesta ---------- */
    document.addEventListener('submit', function (ev) {
      if (ev.target !== form || !attiva || !root.isConnected) return;
      /* V3.3: prima di controllare, ricalcola l'anteprima (se la scritta non sta sul pezzo il testo non è valido) */
      anteprima();
      if (testo && !testo.checkValidity()) {
        ev.preventDefault(); ev.stopImmediatePropagation();
        if (box && box.hidden) { box.hidden = false; root.dataset.x118Aperta = '1'; if (apri) apri.setAttribute('aria-expanded', 'true'); }
        testo.reportValidity();
        return;
      }
      var e = extra();
      if (e <= 0) return;
      var addonId = addon[String(e)];
      if (!addonId) { console.warn('[1221-pers] manca la variante +' + e + ' € del prodotto personalizzazione-1221'); return; }

      var els = Array.prototype.slice.call(form.elements);
      var idEl = form.querySelector('input[name="id"]') || els.filter(function (x) { return x.name === 'id'; })[0];
      var qEl = els.filter(function (x) { return x.name === 'quantity'; })[0];
      var q = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
      var props = els.filter(function (x) {
        return x.name && x.name.indexOf('properties[') === 0 && !x.disabled && ((x.type !== 'radio' && x.type !== 'checkbox') || x.checked);
      });
      var nuovi = [];
      function add(n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; form.appendChild(i); nuovi.push(i); }
      /* V1.30 (30/10/2026, QA-003): prima il prodotto, poi il supplemento come riga «figlia» (parent_id = variante del
         prodotto). Shopify lo mostra sotto la borsa e lo toglie quando si toglie la borsa; assets/1221-v130.js tiene la
         sua quantità uguale a quella della borsa (una personalizzazione per borsa). */
      add('items[0][id]', idEl.value);
      add('items[0][quantity]', q);
      props.forEach(function (p) { add('items[0][' + p.name.replace(/^properties\[/, 'properties][').replace(/\]$/, '') + ']', p.value); });
      add('items[1][id]', addonId);
      add('items[1][quantity]', q);
      add('items[1][parent_id]', idEl.value);
      var variante = (section.querySelector('.variant-picker__option-info span') || {}).textContent || '';
      add('items[1][properties][Per]', root.dataset.titolo + (variante ? ' · ' + variante.trim() : ''));
      if (testo) add('items[1][properties][Testo]', testo.value);

      var spenti = [idEl, qEl].concat(props).filter(Boolean).filter(function (x) { return !x.disabled; });
      spenti.forEach(function (x) { x.disabled = true; });
      setTimeout(function () {
        spenti.forEach(function (x) { x.disabled = false; });
        nuovi.forEach(function (x) { x.remove(); });
      }, 0);
    }, opt({ capture: true }));

    riprendi();
    aggiorna();
  }

  /* V3.3: sul pulsante «Personalizza» (anche quello aggiunto da 1221-v118.js §8) la nota del prezzo viene da data-x-piu,
     per esempio «gratis fino a 3 caratteri» */
  function etichette() {
    document.querySelectorAll('[data-x-pers][data-x-piu]').forEach(function (r) {
      r.querySelectorAll('.x-pers__apri .x-pers__piu').forEach(function (s) {
        if (r.dataset.xPiu && s.textContent !== r.dataset.xPiu) s.textContent = r.dataset.xPiu;
      });
    });
  }
  function start() { document.querySelectorAll('[data-x-pers]').forEach(init); etichette(); }
  window.x1221Pers = { init: init, start: start };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
  /* blocchi ridisegnati dal tema (cambio variante): li inizializza di nuovo */
  var attesa = null;
  new MutationObserver(function () {
    clearTimeout(attesa);
    attesa = setTimeout(function () {
      spegniStaccati();
      document.querySelectorAll('[data-x-pers]').forEach(function (r) { if (!r.__xp) init(r); });
      etichette();
    }, 30);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
